import { HTTP_WH } from "./http";

export const removedContact = (accId, hash) => {
  return HTTP_WH.post(`remove-contact/${accId}/${hash}`).then(result => {
    return result.data;
  });
};

